import React from "react";
import { Transition, Segment, Header } from "semantic-ui-react";

class ActividadesAlumno extends React.Component {
  state = { visible: false };

  componentDidMount() {
    setTimeout(() => this.setState({ visible: true }), 500);
  }
  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Segment>
            <Header content="Actividades" />
          </Segment>
        )}
      </Transition.Group>
    );
  }
}

export default ActividadesAlumno;



// WEBPACK FOOTER //
// ./src/pages/detalleAlumno/ActividadesAlumno.jsx